import React, { useState } from "react";
import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import Translate from "../../../common/translate/Translate";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import { GoogleMapGlobalStyle } from "../components/GoogleMapStyles";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import StoreLocationModalInputCard from "../components/StoreLocationModalInputCard";
import styled from "styled-components";

export function StoreLocationModal({ isOpen, onClose, onConfirm }) {
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    });

    const [center, setCenter] = useState({ lat: 13.7563, lng: 100.5018 });

    const mapOptions = {
        disableDefaultUI: true,
        clickableIcons: false,
        gestureHandling: "greedy",
        styles: [
            {
                //지도에서 장소 아이콘 제거
                featureType: "poi",
                stylers: [{ visibility: "off" }],
            },
        ],
    };

    const handleSave = () => {
        onConfirm({ latitude, longitude, zipCode });
        onClose();
    };

    const [map, setMap] = useState(null);
    const [address, setAddress] = useState("");

    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [zipCode, setZipCode] = useState("");

    const handleSearch = () => {
        if (!address) return;

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: address }, (results, status) => {
            if (status === "OK") {
                if (results[0]) {
                    const { lat, lng } = results[0].geometry.location;
                    const newLat = lat();
                    const newLng = lng();

                    setLatitude(newLat.toString());
                    setLongitude(newLng.toString());
                    setCenter({ lat: newLat, lng: newLng });

                    // Extract zip code
                    const addressComponents = results[0].address_components;
                    const postCodeObj = addressComponents.find((c) => c.types.includes("postal_code"));
                    if (postCodeObj) {
                        setZipCode(postCodeObj.long_name);
                    } else {
                        setZipCode("");
                    }

                    if (map) {
                        map.panTo({ lat: newLat, lng: newLng });
                    }
                } else {
                    console.log("No results found");
                }
            } else {
                console.log("Geocode was not successful for the following reason: " + status);
            }
        });
    };

    const onMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        setLatitude(lat.toString());
        setLongitude(lng.toString());

        // Reverse Geocoding
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === "OK") {
                if (results[0]) {
                    setAddress(results[0].formatted_address);

                    // Extract zip code
                    const addressComponents = results[0].address_components;
                    const postCodeObj = addressComponents.find((c) => c.types.includes("postal_code"));
                    if (postCodeObj) {
                        setZipCode(postCodeObj.long_name);
                    } else {
                        setZipCode("");
                    }
                } else {
                    console.log("No results found");
                }
            } else {
                console.log("Geocoder failed due to: " + status);
            }
        });
    };

    if (!isLoaded) return null;

    return (
        <CustomModal
            title={"Store Location"}
            isOpen={isOpen}
            onClose={onClose}
            width={"839px"}
            height={"90vh"}
            side={"right"}
            contentPadding={"0"}
            bottomButtons={
                <Row justifyContent={"flex-end"} width={"100%"} padding={"22px 20px"}>
                    <SecondaryButton
                        text={Translate("common.cancel")}
                        width={"70px"}
                        padding={"7.75px 14.5px"}
                        onClick={() => {
                            onClose();
                        }}
                    />
                    <SizedBox width={"10px"} />
                    <PrimaryButton
                        text={Translate("common.save")}
                        width={"70px"}
                        padding={"7.75px 14.5px"}
                        onClick={handleSave}
                    />
                </Row>
            }
        >
            <GoogleMapGlobalStyle />
            <MapWrapper>
                <GoogleMap
                    center={center}
                    zoom={10}
                    onLoad={(m) => setMap(m)}
                    onClick={onMapClick}
                    mapContainerStyle={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                    }}
                    options={mapOptions}
                >
                    {latitude && longitude && (
                        <Marker
                            position={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }}
                            icon={{
                                url: `${process.env.PUBLIC_URL}/icons/icon_store_map_pin.png`,
                                scaledSize: new window.google.maps.Size(46, 50),
                            }}
                        />
                    )}
                </GoogleMap>
                <InputCardWrapper>
                    <StoreLocationModalInputCard
                        address={address}
                        setAddress={setAddress}
                        setLatitude={setLatitude}
                        setLongitude={setLongitude}
                        latitude={latitude}
                        longitude={longitude}
                        zipCode={zipCode}
                        setZipCode={setZipCode}
                        onSearch={handleSearch}
                    />
                </InputCardWrapper>
            </MapWrapper>
        </CustomModal>
    );
}

const MapWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 839px;
`;

const InputCardWrapper = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
`;

export default StoreLocationModal;
